import { motion } from 'framer-motion'
import { FaFacebookF, FaLocationDot } from 'react-icons/fa6'
import {
  BsInstagram,
  BsTelephoneFill,
  BsTwitterX,
  BsYoutube
} from 'react-icons/bs'
import { PiCertificateFill } from "react-icons/pi";
// import logo from '../assets/logo-light.svg'

const SocialIcon = ({ children }) => {
  return (
    <div className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-gray-400 bg-opacity-65 text-white'>
      {children}
    </div>
  )
}

const FooterContact = () => {
  const contacts = [
    {
      icon: (
        <PiCertificateFill   className='shrink-0' size={23}  />
      ),
      text: `MOE REGISTRATION CERTIFICATION
            NO:DU002(B)
            `
    },
    {
      icon: <FaLocationDot className='shrink-0' size={23} />,
      text: `PUTRAJAYA CAMPUS UNITEN  Jalan IKRAM-UNITEN 43000 Kajang, Selangor MALAYSIA.
            `
    },
    {
      icon: <BsTelephoneFill className='shrink-0' size={18} />,
      text: '+603-8921 2020 | Putrajaya'
    },
    {
      icon: <FaLocationDot className='shrink-0' size={23} />,
      text: `UNITEN Sultan Haji Ahmad Shah Campus
            Jalan Muadzam, Bukit Ibam, 26810 Muadzam Shah, Pahang.`
    },
    {
      icon: <BsTelephoneFill className='shrink-0' size={18} />,
      text: '+609-455 2020 | KSHAS'
    }
  ]
  const socialIcons = [
    {
      icon: <FaFacebookF />,
      text: 'Facebook',
      link: 'https://www.facebook.com/uniten'
    },
    {
      icon: <BsTwitterX />,
      text: 'Twitter',
      link: 'https://x.com/uniten'
    },
    {
      icon: <BsInstagram />,
      text: 'Instagram',
      link: 'https://www.instagram.com/uniten.official?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
    },
    {
      icon: <BsYoutube />,
      text: 'Youtube',
      link: 'https://www.youtube.com/@UNITENofficial'
    }
  ]
  const logo = '/assets/logo-light.svg'
  return (
    <div className='flex flex-col items-center md:items-start justify-start gap-3 w-full p-2 md:p-0 md:w-2/3'>
      <div className='flex items-start'>
        <img
          src={logo}
          width={500}
          height={500}
          className='w-full h-auto'
          alt='Logo'
        />
      </div>
      <ul className='flex flex-col list-none gap-3 items-start'>
        {contacts.map((contact, index) => (
          <motion.li
            initial={{ x: 0, opacity: 0.8, scale: 1 }}
            whileHover={{
              x: 2,
              opacity: 1,
              scale: 1.01
            }}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20
            }}
            key={index}
            className='group cursor-pointer text-gray-400  text-xs 2xl:text-sm'
          >
            <span className=' flex  gap-3 items-start uppercase whitespace-pre-line'>
              {contact.icon}
              {contact.text}
            </span>
          </motion.li>
        ))}
      </ul>

      <ul className='flex gap-4 items-center list-none justify-center w-full lg:justify-start'>
        {socialIcons.map((socialIcon, index) => (
          <motion.li
            onClick={() => window.open(socialIcon.link, '_blank')}
            initial={{ opacity: 0.8, scale: 1 }}
            whileHover={{
              opacity: 1,
              scale: 1.01
            }}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 20
            }}
            key={index}
            className='group cursor-pointer text-gray-400 '
          >
            <SocialIcon>{socialIcon.icon}</SocialIcon>
          </motion.li>
        ))}
      </ul>
    </div>
  )
}

export default FooterContact
